import { useState, useRef } from "react";
import { Zap, HardHat, Server, Truck, Wrench, Bookmark } from "lucide-react";

const services = [
  {
    icon: Zap,
    number: 1,
    title: "Construcción Eléctrica",
    summary:
      "Ejecución de proyectos de redes de distribución de media y baja tensión, protecciones atmosféricas, estaciones transformadoras e iluminación pública.",
    image: "/images/constelectricas.jpg",
    details: [
      {
        title: "Redes de Distribución de Media y Baja Tensión",
        description: "Diseñamos, analizamos e instalamos redes eléctricas eficientes y seguras, asegurando una óptima distribución de energía. Incluimos estudios de apantallamiento y fundaciones para una infraestructura robusta.",
      },
      {
        title: "Sistemas de Protección Contra Descargas Atmosféricas",
        description: "Implementamos pararrayos y sistemas de protección contra sobretensiones, salvaguardando personas, instalaciones y equipos ante fenómenos eléctricos de alta peligrosidad.",
      },
      {
        title: "Alumbrado Público",
        description: "Planificamos e instalamos soluciones de iluminación pública eficientes, sostenibles y alineadas con los estándares urbanos actuales, fomentando entornos más seguros y funcionales.",
      },
      {
        title: "Estaciones Transformadoras",
        description: "Diseñamos y construimos estaciones transformadoras que aseguran la conversión eficiente de energía, adaptándonos a distintos niveles de tensión. Realizamos estudios de factibilidad, diseño conceptual y desarrollo de subestaciones primarias y secundarias.",
      },
      {
        title: "Construcciones, Montajes y Mantenimientos Eléctricos",
        description: "Ejecutamos proyectos integrales de instalación, montaje y mantenimiento de sistemas eléctricos, garantizando rendimiento óptimo, cumplimiento normativo y continuidad operativa.",
      },
    ],
  },
  {
    icon: HardHat,
    number: 2,
    title: "Ingeniería Especializada",
    summary:
      "Consultoría en ingeniería EPC: supervisión, inspección, estudios de prefactibilidad y desarrollo de proyectos ejecutivos.",
    image: "/images/ingespecializada.jpg",
    details: [
      {
        title: "Ingeniería, Procura y Gerenciamiento de Proyectos (EPC)",
        description: "Nos encargamos de la planificación, ejecución, supervisión e inspección integral de proyectos, asegurando el cumplimiento de plazos, estándares de calidad, normativas técnicas y seguridad en obra.",
      },
      {
        title: "Estudios de Prefactibilidad y Factibilidad",
        description: "Realizamos análisis técnicos y económicos preliminares que permiten evaluar riesgos, oportunidades y la viabilidad integral de cada iniciativa, identificando los factores clave para su éxito.",
      },
      {
        title: "Asesorías y Auditorías Especializadas",
        description: "Brindamos consultorías en ingeniería conceptual, básica, de detalle y de campo. Detectamos oportunidades de mejora, optimizamos procesos y acompañamos en la toma de decisiones críticas para proyectos complejos.",
      },
      {
        title: "Desarrollo de Ingeniería, Anteproyectos y Proyectos Ejecutivos",
        description: "Elaboramos anteproyectos, diseños técnicos y documentación ejecutiva para obras civiles y electromecánicas, alineados con los estándares normativos vigentes y las mejores prácticas del sector.",
      },
    ],
  },
  {
    icon: Server,
    number: 3,
    title: "Infraestructura Tecnológica",
    summary:
      "Diseño e implementación de data centers, radio bases, sistemas de control y automatización e infraestructura IT.",
    image: "/images/infraestructuratecnologica.jpg",
    details: [
      {
        title: "Proyectos Tecnológicos",
        description: "Diseñamos y ejecutamos obras especializadas en telecomunicaciones, energía, minería, industrias, data centers y más. Desarrollamos soluciones a medida en infraestructura tecnológica, incluyendo edificios técnicos de telefonía, radio bases y salas de energía.",
      },
      {
        title: "Infraestructura Corporativa",
        description: "Construimos y acondicionamos oficinas, locales comerciales, plantas industriales y espacios complementarios, incluyendo remodelaciones y mantenimiento integral.",
      },
      {
        title: "Gestión Integral de Proyectos",
        description: "Brindamos soluciones integrales desde el estudio del terreno hasta la ejecución y mantenimiento de obras civiles, electromecánicas, ICT, termomecánicas, sistemas de seguridad y más. Contamos con laboratorio propio para ensayos y control de calidad.",
      },
      {
        title: "Productos Electromecánicos",
        description: "Contamos con experiencia en el diseño, suministro y construcción de automatismos, tableros eléctricos, infraestructura IT, sistemas de distribución y control, cumpliendo con las principales normativas internacionales (Uptime Institute, ANSI/TIA/EIA, ISO, IEC, NFPA).",
      },
    ],
  },
  {
    icon: Truck,
    number: 4,
    title: "Logística y Transporte",
    summary:
      "Movilización y traslado especializado de equipos pesados, transformadores, generadores y estructuras de gran porte.",
    image: "/images/logisticaytransporte.jpg",
    details: [
      {
        title: "Transporte especializado de Equipos y Maquinaria",
        description: "Traslado seguro de cargas de gran volumen o peso, incluyendo transformadores, tableros y estructuras metálicas.",
      },
      {
        title: "Soporte Logístico Integral",
        description: "Planificación técnica, rutas de acceso, permisos y coordinación operativa para asegurar eficiencia y cumplimiento normativo.",
      },
      {
        title: "Cobertura en Proyectos Industriales y de Infraestructura Compleja",
        description: "Experiencia en sectores mineros, energéticos y de telecomunicaciones, entre otros.",
      },
      {
        title: "Enfoque en Seguridad y Precisión",
        description: "Procedimientos certificados que garantizan el resguardo de los equipos y la integridad del personal en cada fase de la operación.",
      },
    ],
  },
  {
    icon: Wrench,
    number: 5,
    title: "Alquiler de Equipos",
    summary:
      "Flota propia de equipos pesados y livianos con operarios calificados para movimiento de suelos y canalizaciones.",
    image: "/images/alquilerequipo.jpg",
    details: [
      {
        title: "Flota de Excavación y Movimiento de Tierras",
        description: "Maquinaria versátil como retroexcavadoras y retrocargadoras de alto rendimiento. Ideales para la apertura de zanjas en proyectos eléctricos, excavaciones para fundaciones y movimientos de suelo en espacios urbanos o industriales, con mantenimiento preventivo al día.",
      },
      {
        title: "Equipos de Izaje y Carga Liviana",
        description: "Grúas de hasta 6 toneladas y minicargadoras para la manipulación precisa de materiales en obra. Perfectas para el montaje de transformadores pequeños, postes y estructuras metálicas livianas, con agilidad para limpieza y carga en sectores de acceso restringido.",
      },
      {
        title: "Logística de Traslado con Carretón Especializado",
        description: "Transporte pesado mediante carretón para el traslado eficiente y seguro de maquinaria hacia los distintos frentes de obra, así como componentes de infraestructura de gran volumen que requieren plataforma de carga baja y reforzada.",
      },
      {
        title: "Disponibilidad Operativa y Operadores Calificados",
        description: "Solución integral que incluye operadores certificados con amplia experiencia en proyectos de infraestructura. Respuesta rápida ante contingencias, asistencia técnica en terreno y cumplimiento estricto de normas de seguridad y salud ocupacional.",
      },
    ],
  },
];

export default function Services() {
  const [activeIndex, setActiveIndex] = useState(0);
  const detailRef = useRef(null);
  const active = services[activeIndex];

  const handleSelect = (index) => {
    setActiveIndex(index);
    setTimeout(() => {
      detailRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 50);
  };

  return (
    <section id="services" className="relative bg-white py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-[0.25em] mb-3">
            Servicios
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 uppercase tracking-tight">
            Servicios que impulsan{" "}
            <span className="text-amber-600">tu obra</span>
          </h2>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-6 mb-20">
          {services.map((service, index) => (
            <ServiceCard
              key={service.number}
              service={service}
              isActive={index === activeIndex}
              onClick={() => handleSelect(index)}
            />
          ))}
        </div>

        {/* Detail Section */}
        <div
          ref={detailRef}
          key={activeIndex}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center animate-fadeIn scroll-mt-8"
        >
          {/* Left - Feature list */}
          <div className="space-y-8">
            {active.details.map((detail, i) => (
              <div key={i} className="flex gap-5">
                <div className="flex-shrink-0 w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center shadow-md">
                  <Bookmark className="text-white" size={24} strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-slate-900 font-bold text-lg leading-snug mb-1">
                    {detail.title}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {detail.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right - Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={active.image}
                alt={active.title}
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, isActive, onClick }) {
  const Icon = service.icon;

  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center text-center group cursor-pointer transition-all duration-300 rounded-2xl py-6 px-3 ${
        isActive
          ? "bg-amber-50 shadow-lg shadow-amber-100 ring-2 ring-amber-400"
          : "hover:bg-slate-50"
      }`}
    >
      {/* Numbered circle with icon */}
      <div className="relative mb-5">
        <div
          className={`absolute -top-1 -left-1 w-7 h-7 text-white text-xs font-bold rounded-full flex items-center justify-center z-10 shadow-md transition-colors duration-300 ${
            isActive ? "bg-amber-600" : "bg-amber-500"
          }`}
        >
          {service.number}
        </div>
        <div
          className={`w-24 h-24 rounded-full border-2 border-dashed flex items-center justify-center transition-all duration-300 ${
            isActive
              ? "border-amber-500 bg-amber-100"
              : "border-amber-400 bg-amber-50 group-hover:bg-amber-100 group-hover:border-amber-500"
          }`}
        >
          <Icon className="text-amber-600" size={36} strokeWidth={1.5} />
        </div>
      </div>

      {/* Title */}
      <h3
        className={`font-bold text-base leading-tight min-h-[2.5rem] flex items-center transition-colors duration-300 ${
          isActive ? "text-amber-700" : "text-slate-900"
        }`}
      >
        {service.title}
      </h3>

      {/* Summary */}
      <p className="text-slate-500 text-sm leading-relaxed px-1 mt-2">
        {service.summary}
      </p>
    </button>
  );
}
